import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { ComumModule } from '../comum/comum.module';
import { routing } from '../rotas';
import { FormsModule } from '@angular/forms';
import { ProcessoService } from './processo.service';
import { SetorService } from '../setor/setor.service';
import { SetorModule } from '../setor/setor.module';
import { CadastroProcessoComponent } from './cadastro-processo/cadastro-processo.component';
import { ListarProcessosComponent } from './listar-processos/listar-processos.component';
import { ListarSetoresClienteProcessoComponent } from './listar-setores-cliente-processo/listar-setores-cliente-processo.component';
import { ProcessoTabsetComponent } from './processo-tabset/processo-tabset.component';
import { ListarProcessosClienteComponent } from './listar-processos-cliente/listar-processos-cliente.component';
import { ModalProcessosClienteComponent } from './modal-processos-cliente/modal-processos-cliente.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule,
    PipesModule,
    ComumModule,
    SetorModule,
    routing,
    FormsModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    })
  ],
  declarations: [CadastroProcessoComponent, ListarProcessosComponent, ProcessoTabsetComponent,
  ListarSetoresClienteProcessoComponent, ListarProcessosClienteComponent, ModalProcessosClienteComponent],
  exports: [CadastroProcessoComponent, ListarProcessosComponent, ProcessoTabsetComponent,
  ListarSetoresClienteProcessoComponent, ListarProcessosClienteComponent, ModalProcessosClienteComponent],
  providers: [SetorService, ProcessoService, CookieService]
})
export class ProcessoModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/processo/processo.module.ts